import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {pageRoutes} from '../constants/pageRoutes';
import ManageCandidate from '../pages/ManageCandidate';
import ManageJob from '../pages/ManageJob';
import ManageUser from '../pages/ManageUser';
import ManageRevenue from '../pages/ManageRevenue';
import ManageCMS from '../pages/ManageCMS';
import UserActivity from '../components/UserActivity';
import ManageSubject from '../pages/ManageSubject';
import AddQuestions from '../components/Test/AddQuestions';
import Questions from '../pages/Questions';
import ManageSkills from '../pages/ManageSkill';
import JobDetails from '../pages/JobDetails';
import EditJob from '../components/EditJob';
import JobManagement from '../pages/JobManagement';
import DashboardV2 from '../pages/DashboardV2';
import CodingChallenge from '../pages/CodingChallenge';
import CodingQuestion from '../components/codingChallenge/CodingQuestion';
import EditCodingProblem from '../components/codingChallenge/EditCodingProblem';
import CodingSubmission from '../pages/CodingSubmission';
import ViewTestSubmission from '../components/codingSubmission/ViewTestSubmission';
import AssessmentList from '../pages/assessment/AssessmentList';
import AssessmentForm from '../pages/assessment/AssessmentForm';
import AssessmentCandidates from '../pages/assessment/AssessmentCandidates';

const DashboardRoutes = () => {
  return (
    <Routes>
      <Route path={pageRoutes.dashboard} element={<DashboardV2 />} />

      <Route path={pageRoutes.manageCandidate} element={<ManageCandidate />} />
      <Route path={pageRoutes.manageUser} element={<ManageUser />} />
      <Route path={pageRoutes.manageRevenue} element={<ManageRevenue />} />
      <Route path={pageRoutes.manageCMS} element={<ManageCMS />} />

      {/* Job */}
      <Route path={pageRoutes.manageJob} element={<ManageJob />} />
      <Route path="edit-job/:jobId" element={<EditJob />} />
      <Route path={`${pageRoutes.manageJob}/:jobId`} element={<JobDetails />} />
      <Route
        path={`${pageRoutes.jobManagement}/:jobId`}
        element={<JobManagement />}
      />

      {/* Test Module */}
      <Route path={pageRoutes.subjects} element={<ManageSubject />} />
      <Route path={pageRoutes.skills} element={<ManageSkills />} />
      <Route path={pageRoutes.addQuestions} element={<AddQuestions />} />
      <Route path={pageRoutes.questions} element={<Questions />} />
      <Route
        path="edit-question/:questionId"
        element={<AddQuestions editMode />}
      />

      {/* Assessment Management */}
      <Route path={pageRoutes.assessments} element={<AssessmentList />} />
      <Route path={pageRoutes.createAssessment} element={<AssessmentForm />} />
      <Route
        path={`${pageRoutes.editAssessment}/:id`}
        element={<AssessmentForm />}
      />
      <Route
        path={`${pageRoutes.assessments}/:id/candidates`}
        element={<AssessmentCandidates />}
      />

      <Route
        path={`${pageRoutes.candidate}/:jobId`}
        element={<UserActivity />}
      />
      <Route
        path={`${pageRoutes.employer}/:userId`}
        element={<UserActivity />}
      />

      <Route path="*" element={<Navigate to={pageRoutes.dashboard} />} />

      {/* Coding Challenge */}
      <Route path={pageRoutes.codingChallenge} element={<CodingChallenge />} />
      <Route path={pageRoutes.codingProblem} element={<CodingQuestion />} />
      <Route
        path={`${pageRoutes.editCodingProblem}/:problemId`}
        element={<EditCodingProblem />}
      />

      {/* coding submission */}
      <Route
        path={pageRoutes.codingSubmission}
        element={<CodingSubmission />}
      />
      <Route
        path={`${pageRoutes.viewTestSubmission}/:testId`}
        element={<ViewTestSubmission />}
      />
    </Routes>
  );
};

export default DashboardRoutes;
